<template>
    <div class="timeline-container">
        <Top class="timeline-top-banner"></Top>
        <div class="timeline-main">
            <TimeArea :data="data"></TimeArea>
            <div class="timeline-line"></div>
            <div class="timeline-block">
                <div class="timeline-title">
                    <div class="timeline-title-text">
                        {{ data.theme }}
                    </div>
                    <img class="timeline-title-edit" :src="require(`@/assets/images/icon/add.png`)"
                        v-if="data.can_add && $tools.isExecutor()" alt="" @click="addPhase(data)">
                    <!-- <img class="timeline-title-edit" :src="require(`@/assets/images/icon/remove.png`)" v-if="data.can_remove && $tools.isExecutor()" alt=""
                        @click="removePhase(data)"> -->
                </div>
                <div class="timeline-ul">
                    <div class="timeline-li" v-for="(item, index) in data.list" :key="item.name">
                        <div class="timeline-name" :class="{ 'timeline-tag': isTagName(item) }">{{ item.name }}</div>
                        <div class="timeline-hospital" :class="{ 'timeline-tag': isTagName(item) }">{{ item.hospital }}</div>
                        <img v-if="!isCanSign" class="timeline-edit" :src="require(`@/assets/images/icon/edit.png`)" alt="" @click="editDoctor(item)">
                        <!-- 未签署 -->
                        <img v-if="isCanSign && item.sign_status == 0" class="timeline-edit" :src="require(`@/assets/images/icon/sign-name.png`)" alt="" 
                        @click="goAgreement(item)">
                         <!-- 已签署 -->
                         <img v-if="isCanSign && item.sign_status == 1" class="timeline-edit" :src="require(`@/assets/images/icon/sign-name2.png`)" alt="" 
                        @click="goAgreement(item)">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Top from './top.vue'
import TimeArea from './timeArea.vue'
import MyPopup from '@/components/unit/PagePopup.js'
import login from './login'
export default {
    name: "timeLine",
  mixins:[login],
    data() {
        return {
            loading: false,
        }
    },
    props: {
        data: {
            type: Object,
            default: () => {
                return {}
            }
        },
        meetInfo:{
            type:Object,
            default:()=>{
                return {
                }
            }
        }
    },
    components: {
        Top,
        MyPopup,
        TimeArea
    },
    computed:{
        isCanSign(){
            return this.meetInfo?.meet_info?.status == 4 && this.meetInfo?.meet_info?.audit_status >= 40
        }
    },
    methods: {
        isTagName(item) {
            return this.$tools.verifyDoctorInfo(item)
        },
        async addPhase() {
            console.log(111)
            try{
                await this.login()
            }catch(err){
                console.log(err)
                return;
            }
            if (this.loading) return;
            this.loading = true
            MyPopup({ content: ["请问是否新增分享阶段"], cancelText: "取消", comfirmText: "确认" }).then(res => {
                let loading = this.$tips.loading({ text: "新增中..." })
                let url = this.$tools.getURL(this.$urls.meet.phase,  {meet_id:this.$route.query.id})
                this.$axios.get(url).then(res => {
                    setTimeout(() => {
                        this.$tips.success({ text: "新增阶段成功" })
                        this.loading = false;
                        loading.close()
                        this.$emit('updateMeetInfo')
                    }, 1000)
                }).catch(err => {
                    setTimeout(() => {
                        this.loading = false;
                        loading.close()
                    }, 1000)

                })
            }).catch(err => {
                setTimeout(() => {
                    this.loading = false;
                }, 1000)

            })
        },
        async removePhase() {
            try{
                await this.login()
            }catch(err){
                console.log(err)
                return;
            }
            if (this.loading) return;
            this.loading = true
            let phase = this.data.phase == 4 ? 2 : 1
            MyPopup({ content: [`请问是否删除分享阶段${phase}`], cancelText: "取消", comfirmText: "确认" }).then(res => {
                let loading = this.$tips.loading({ text: "删除中..." })
                let url = this.$tools.getURL(this.$urls.meet.phase, {meet_id:this.$route.query.id,phase:this.data.phase})
                this.$axios.delete(url).then(res => {
                    setTimeout(() => {
                        this.$tips.success({ text: "删除阶段成功" })
                        this.loading = false;
                        loading.close()
                        this.$emit('updateMeetInfo')
                    }, 1000)
                }).catch(err => {
                    setTimeout(() => {
                        this.loading = false;
                        loading.close()
                    }, 1000)

                })
            }).catch(err => {
                setTimeout(() => {
                    this.loading = false;
                }, 1000)

            })
        },
        goAgreement() {
            this.$router.push({
                path: "/collaborator",
            })
        },
        async editDoctor(data) {
            try{
                await this.login()
            }catch(err){
                console.log(err)
                return;
            }
            this.$router.push({
                path: "/doctor",
                query: {
                    phase: data.phase,
                    id: data.doctor_id,
                    link_id: data.link_id,
                    link_index: data.link_index,
                    need_class: data.need_class,
                    meet_id: this.$route.query.id,
                    come_from: 1 //1= 日程信息，2=签署协议信息
                }
            })
        },
    },

}
</script>

<style scoped>
.timeline-container {
    display: flex;
    color: #231815;
    font-size: 13px;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
    background: #fff;
    margin: 0 13px;
    width: calc(100% - 26px);
}

.timeline-main {
    display: flex;
    flex: 1 0 0;
    padding: 9px 8px;
}

.timeline-top-banner {
    flex: 4.5px 0 0;
    height: auto;
}

.timeline-line {
    width: 1px;
    height: auto;
    background: #DCDCDC;
    border-radius: 0px;
}

.timeline-block {
    display: flex;
    flex-direction: column;
    flex: 1 0 0;
    line-height: 18px;
    margin-left: 12px;
}

.timeline-title-can-opera {
    flex: 1 0 0;
}

.timeline-title-not-opera {
    width: 209px;
}

.timeline-title {
    font-weight: 700;
    word-break: break-all;
    display: flex;
    justify-content: space-between;
}

.timeline-title-text {
    width: 219px;
    flex: 1 0 0;
    margin-right: 10px;
}

.timeline-title-edit {
    height: 14px;
    width: 14px;
    margin-right: 5px;
}

.timeline-ul {
    width: 100%;
    margin-top: 10px;
}

.timeline-li {
    display: flex;
    width: 100%;
    font-weight: 400;
    line-height: 18px;
    height: 24px;
    align-items: center;
}

.timeline-name {
    width: 42px;
    margin-right: 12px;
}

.timeline-hospital {
    flex: 1 0 0;
}

.timeline-edit {
    height: 18px;
    width: 18px;
}

.timeline-tag {
    color: #C00000;
}
</style>
